import React from 'react';
import { Box, Typography, Button, Grid, Paper } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useHistory } from 'react-router-dom';

const OrderManagementDoc = () => {
  const history = useHistory();

  const steps = [
    {
      title: 'Accessing the Orders Page',
      intro: 'Track and manage all your past and active orders easily from the Orders section.',
      points: [
        '• Click on the "Orders" tab from the top navigation bar.',
        '• View all your placed catalog and tasking orders in a list format.',
        '• Quickly check key details like Order ID, Order Name, Type, and Current Status.'
      ],
      image: '/images/orders_page.png'
    },
    {
      title: 'Understanding Order Status',
      intro: 'Each order progresses through a series of statuses. Understanding them helps monitor progress.',
      points: [
        '• Draft: Order is saved but not yet finalized.',
        '• Requested: Order has been submitted for processing.',
        '• Accepted: Order is being validated or scheduled.',
        '• Captured (for Tasking): Imagery has been successfully acquired.',
        '• Delivered: Data is processed and ready for download.',
        '• Failed/On-Hold: Indicates issues or manual intervention needed.'
      ],
      image: '/images/order_status.png'
    },

    {
      title: 'Previewing Imagery on the Map',
      intro: 'Visualize the delivered imagery directly on the interactive map.',
      points: [
        '• Preview selected images aligned with your AOI on the map.',
        '• Toggle visibility of specific images for better map analysis.',
        '• View metadata like capture date, cloud cover, resolution, and coverage %.'
      ],
      image: '/images/preview_on_map.png'
    },
    {
      title: 'Downloading Your Data Products',
      intro: 'Download final processed imagery and auxiliary files easily from the platform.',
      points: [
        '• Click the "Download" button available once an order is delivered.',
        '• Downloaded products are typically provided as .zip packages.',
        '• Ensure your selected format (e.g., GeoTIFF, JPEG) matches your analysis needs.',
        '• You can also download specific scenes individually if needed.'
      ],
      image: '/images/download_products.png'
    }
  ];

  return (
    <Box sx={{ maxWidth: '1000px', mx: 'auto', p: 4 }}>
      <Button startIcon={<ArrowBackIcon />} sx={{ mb: 4, color: '#1976d2' }} onClick={() => history.push("/documentation")}>
        Back to Documentation
      </Button>

      <Typography variant="h4" sx={{ mb: 4, fontWeight: 'bold', color: '#1976d2' }}>
        Order Management - Tracking and Managing Orders
      </Typography>

      {steps.map((step, index) => (
        <Paper elevation={3} sx={{ p: 3, mb: 4, borderRadius: 2 }} key={index}>
          <Grid container spacing={3} alignItems="center">
            <Grid item xs={12} md={6}>
              <Typography variant="h6" sx={{ mb: 2, color: '#333', fontWeight: 600 }}>{`${index + 1}. ${step.title}`}</Typography>
              <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>{step.intro}</Typography>
              {step.points.map((point, idx) => (
                <Typography key={idx} variant="body2" color="text.secondary" sx={{ ml: 2, mb: 1 }}>{point}</Typography>
              ))}
            </Grid>
            <Grid item xs={12} md={6}>
              <Box
                component="img"
                src={step.image}
                alt={step.title}
                sx={{ width: '100%', height: 'auto', borderRadius: 2, boxShadow: 3 }}
              />
            </Grid>
          </Grid>   </Paper>))}
      
    </Box>
  );
};

export default OrderManagementDoc;
